module.exports={
	"Form": "PhysicalAssetMaterialCreateManifest",
	"Scope": "PhysicalAssetMaterial-Create",
	"Descriptors":
	{
		"PhysicalAssetMaterialDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetMaterial-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Create-Identity",
				"Group": "PhysicalAssetMaterial-Create-Identity"
			}
		},
		"PhysicalAssetMaterialDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-Create-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Create-Details",
				"Group": "PhysicalAssetMaterial-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"PhysicalAssetMaterialDetails.Material":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-Create-Material",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-Create-Details",
				"Group": "PhysicalAssetMaterial-Create-Details"
			}
		},
		"PhysicalAssetMaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetMaterial-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetMaterial-Create-Details",
				"Group": "PhysicalAssetMaterial-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetMaterial-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetMaterial-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetMaterial-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetMaterial-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
